/**
 *
 * @see https://github.com/draft-js-plugins/draft-js-plugins/blob/master/draft-js-focus-plugin/src/utils/getBlockMapKeys.js
 *
 * @param {Draft.ContentState} content
 * @param {Draft.SelectionState} selection
 */
export function getBlockMapKeys(content, selection) {
	const startKey = selection.getStartKey();
	const endKey = selection.getEndKey();
	const blockMapKeys = content.getBlockMap().keySeq();
	return blockMapKeys
		.skipUntil(key => key === startKey)
		.takeUntil(key => key === endKey)
		.concat([endKey]);
}



// WEBPACK FOOTER //
// ./lib/helpers/getBlockMapKeys.js